export const PXCalculators = (function () {
    "use strict";

    let $calculate_button;

    function init() {
        $calculate_button = $(".calculator-form .btn");

        if ($calculate_button) {
            events();
        }
    }

    function calculate(type, $inputs) {
        let value;
        switch (type) {
            case "average_depth":
                value = (parseFloat($inputs[0].value) + parseFloat($inputs[1].value)) / 2;
                return value;
                break;
            case "free_form_capacity":
                value = parseFloat($inputs[0].value) * parseFloat($inputs[1].value);
                return value;
                break;
            case "rectangular_capacity":
                let area = parseFloat($inputs[0].value) * parseFloat($inputs[1].value);
                value = area * parseFloat($inputs[2].value);
                return value;
                break;
            case "circular_capacity":
                value =
                    Math.PI *
                    ((parseFloat($inputs[0].value) / 2) *
                        (parseFloat($inputs[0].value) / 2) *
                        parseFloat($inputs[1].value));
                return value;
                break;
            case "oval_capacity":
                let dia_1 = parseFloat($inputs[0].value);
                let dia_2 = parseFloat($inputs[1].value);
                let ave_dia = (dia_1 + dia_2) / 2;
                value = Math.PI * ((ave_dia / 2) * (ave_dia / 2)) * parseFloat($inputs[2].value);
                return value;
                break;
            default:
                return false;
        }
    }

    function events() {
        $calculate_button.click(function (e) {
            e.preventDefault();

            let $t = $(this),
                $calculator_form = $t.closest(".calculator-form"),
                type = $calculator_form.attr("name"),
                $inputs = $calculator_form.find("input[type='number']"),
                $result = $calculator_form.find(".result-value"),
                value,
                label = type === "average_depth" ? " ft." : " gallons",
                has_error = false;

            $inputs.each(function (i) {
                let $input = $($inputs[i]);
                if ($input.val() === "" || Number.isNaN($input.val())) {
                    $input.addClass("error");
                    has_error = true;
                } else {
                    $input.removeClass("error");
                }
            });

            if ($inputs && !has_error) {
                value = calculate(type, $inputs);
                if (!Number.isNaN(value)) {

                    if (type === "average_depth") {
                        $result.html(Math.round(value * 100) / 100 + label);
                    } else {
                        $result.html(Math.round(value * 100 * 7.5) / 100 + label);
                    }
                    
                } else {
                    console.log("ERROR");
                }
            }
        });
    }

    return {
        init: init,
    };
})();
